import { Api } from './client'
import { v1 } from '../../config/api'

export const ApiClientV1 = new Api(v1)
